<template>
	<modal :title="title" :id="id" :saveAction="false" :actionButtons="false" size="full" @shown="shown" @hidden="hidden">
		<div id="printContent" class="exam-desc-print-modal">
			<div class="container page-break-after">
				<div class="row">
					<div class="col-12">
						<company-print-header></company-print-header>
					</div>
					<div class="col-12 my-4"><hr></div>
					<div class="col-12" v-if="exam.description" v-html="exam.description"></div>
				</div>
			</div>
		</div>

		<template slot="modal-footer">
			<slot name="modal-footer">
				<div class="card-footer" style="display: block;">
					<div class="row">
						<div class="col"></div>
						<div class="col-auto">
							<button
								class="btn mr-3 btn-outline-primary"
								v-b-tooltip
								:title="$t('Print')"
								@click="print()"
							>
								<i class="fe fe-printer"></i>
							</button>
							<button class="btn btn-outline-secondary ml-2" @click="hide">
								{{$t("Close")}}
							</button>
						</div>
					</div>
				</div>
			</slot>
		</template>
	</modal>
</template>

<script>
import {mapGetters, mapState, mapActions} from "vuex";
import Modal from "@/components/Modal.vue";
import {modalMixins} from '@/mixins/modal.js'
import CompanyPrintHeader from "@/components/Company/CompanyPrintHeader.vue";

export default {
	name: "PrintExamDescription",
	props: ['id'],
	mixins: [modalMixins],
	components: {
		CompanyPrintHeader,
		Modal,
	},
	data() {
		return {
			exam: {},
			title: '',
			width: '50px',
			height: '50px',
			printImages: false,
			isTableDisplay: false
		}
	},
	methods: {
		...mapActions('customers', {getCustomers: 'get'}),

		shown() {
			const {Exam} = this.$FeathersVuex;
			let data = Exam.getFromStore('temp');
			if (data) {
				delete data._id;
				this.exam = this.$copy(data.exam);
				new Exam({
					model: {},
					_id: 'temp'
				});
			}
		},

		hidden() {
			var $printSection = document.getElementById("printSection");
			if ($printSection) {
				$printSection.remove();
			}
		},

		hide() {
			this.$root.$emit('bv::hide::modal', this.id)
		},

		print() {
			var domClone = document.getElementById("printContent").cloneNode(true);

			var $printSection = document.getElementById("printSection");
			if (!$printSection) {
				var $printSection = document.createElement("div");
				$printSection.id = "printSection";
				document.body.appendChild($printSection);
			}

			$printSection.innerHTML = "";
			$printSection.appendChild(domClone);
			window.print();
		},
	},
	computed: {
		...mapState('auth', ['user']),
		...mapGetters('customers', {getCustomer: 'get'}),
		...mapGetters('company', {getTechnicianFromStore: 'get'}),

		customer() {
			return this.getCustomer(this.exam.customerId);
		},
	},
}
</script>

<style lang="scss">
.exam-desc-print-modal p {
	line-height: 28px;
}
</style>

<style lang="scss" scoped>

.empty-area {
	display: inline-block;
	height: 20px;
	border-bottom: 1px solid #95AAC9;
}

@media screen {
	#printContent {
		position: relative;
		height: 78vh;
		width: 100%;
		overflow: auto;
		overflow-x: hidden;
	}
}

</style>
